import { render, staticRenderFns } from "./content-title.vue?vue&type=template&id=177a269e&scoped=true"
import script from "./content-title.vue?vue&type=script&lang=ts"
export * from "./content-title.vue?vue&type=script&lang=ts"
import style0 from "./content-title.vue?vue&type=style&index=0&id=177a269e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177a269e",
  null
  
)

export default component.exports